import script from "./MemberInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberInformation.vue?vue&type=script&setup=true&lang=js"

import "./MemberInformation.vue?vue&type=style&index=0&id=594179a7&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebase 8x8\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-594179a7"]])

export default __exports__